import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import ALink from 'tradera-components/alink/alink';
import { LiveShoppingIcon } from 'tradera-apps/tradera/components/live-shopping/live-shopping-icon';

const LiveShoppingLink = ({ featureSwitches, useLink, transparentHeader }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <ALink
            useLink={useLink}
            aria-label="Live auctions"
            href={toLocalizedUrl('/live')}
            className={`btn slim-header__link-text px-1 px-md-1 ${
                transparentHeader
                    ? 'btn-transparent-header'
                    : 'btn-link-branded'
            }`}>
            <LiveShoppingIcon
                animated={featureSwitches['live-shopping-is-live']}
                className="icon-md"
            />
            <span className="slim-header__link-text d-none d-sm-block ml-1">
                {t('siteHeader_liveShopping')}
            </span>
        </ALink>
    );
};

export default LiveShoppingLink;
